import { REQUEST_DETAILS_SUMMARY_BOX_CONFIRMATION_DESCRIPTIONS } from "./constants";

export const getRequestDetailsSummaryBoxConfirmationDescription = (confirmationText: string): string =>
  REQUEST_DETAILS_SUMMARY_BOX_CONFIRMATION_DESCRIPTIONS[confirmationText] || REQUEST_DETAILS_SUMMARY_BOX_CONFIRMATION_DESCRIPTIONS.default;
